var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMailMonthToDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 270.256,
    viewBox: "0 0 332 270.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3126",
    "data-name": "Group 3126",
    transform: "translate(-549 -2964.744)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Last_Update:",
    "data-name": "Last Update:",
    transform: "translate(795 2978.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.704,
    y: 0
  }, "Last Update:")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    width: 161,
    height: 239,
    transform: "translate(549 2996)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 161,
    height: 239,
    transform: "translate(720 2996)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Total_Mailers_This_Month_Calls_Mailer_to_Call_Call_Conversion_New_Patients",
    "data-name": "Total Mailers This Month Calls Mailer to Call % Call Conversion % New Patients",
    transform: "translate(695 3036.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -132.234,
    y: 0
  }, "Total Mailers This Month"), /*#__PURE__*/React.createElement("tspan", {
    x: -26.35,
    y: 44
  }, "Calls"), /*#__PURE__*/React.createElement("tspan", {
    x: -81.756,
    y: 88
  }, "Mailer to Call %"), /*#__PURE__*/React.createElement("tspan", {
    x: -94.963,
    y: 132
  }, "Call Conversion %"), /*#__PURE__*/React.createElement("tspan", {
    x: -70.852,
    y: 176
  }, "New Patients")), /*#__PURE__*/React.createElement("text", {
    id: "_5_000_20_.025_50_5",
    "data-name": "5,000 20 .025% 50% 5",
    transform: "translate(800 3036.744)",
    fill: "#329998",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.097,
    y: 0
  }, "5,000"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.861,
    y: 44
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.761,
    y: 88
  }, ".025%"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 132
  }, "50%"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 176
  }, "5")), /*#__PURE__*/React.createElement("text", {
    id: "Metric",
    transform: "translate(695 3016.744)",
    fill: "#a7a9ac",
    fontSize: 8,
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.472,
    y: 0
  }, "METRIC")), /*#__PURE__*/React.createElement("text", {
    id: "RESULT",
    transform: "translate(800 3016.744)",
    fill: "#a7a9ac",
    fontSize: 8,
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.932,
    y: 0
  }, "RESULT")), /*#__PURE__*/React.createElement("text", {
    id: "November_2020",
    "data-name": "November 2020",
    transform: "translate(550 2981.744)",
    fill: "#329998",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "November 2020")), /*#__PURE__*/React.createElement("text", {
    id: "_11_25_2020",
    "data-name": "11/25/2020",
    transform: "translate(805 2977.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11/25/2020")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailMonthToDate);
export default __webpack_public_path__ + "static/media/directMailMonthToDate.232f9932.svg";
export { ForwardRef as ReactComponent };